export type LocationOption = {
  label: string;
  value: string;
};

export const COUNTRY_OPTIONS: LocationOption[] = [
  {label: 'ישראל', value: 'israel'},
];

export const ISRAEL_STATE_OPTIONS: LocationOption[] = [
  {label: 'צפון', value: 'north'},
  {label: 'חיפה', value: 'haifa'},
  {label: 'מרכז', value: 'center'},
  {label: 'תל אביב', value: 'tel-aviv'},
  {label: 'ירושלים', value: 'jerusalem'},
  {label: 'דרום', value: 'south'},
];

const ISRAEL_CITIES_BY_STATE: Record<string, LocationOption[]> = {
  north: [
    {label: 'עכו', value: 'acre'},
    {label: 'נהריה', value: 'nahariya'},
    {label: 'צפת', value: 'safed'},
    {label: 'טבריה', value: 'tiberias'},
    {label: 'נצרת', value: 'nazareth'},
    {label: 'עפולה', value: 'afula'},
    {label: 'כרמיאל', value: 'karmiel'},
    {label: 'מעלות-תרשיחא', value: 'maalot-tarshiha'},
    {label: 'קריית שמונה', value: 'kiryat-shmona'},
    {label: 'מגדל העמק', value: 'migdal-haemek'},
    {label: 'שפרעם', value: 'shefa-amr'},
    {label: 'טמרה', value: 'tamra'},
    {label: 'סחנין', value: 'sakhnin'},
    {label: 'מעיליא', value: 'maaliya'},
    {label: 'בית שאן', value: 'beit-shean'},
  ],
  haifa: [
    {label: 'חיפה', value: 'haifa-city'},
    {label: 'חדרה', value: 'hadera'},
    {label: 'נשר', value: 'nesher'},
    {label: 'קריית אתא', value: 'kiryat-ata'},
    {label: 'קריית ביאליק', value: 'kiryat-bialik'},
    {label: 'קריית ים', value: 'kiryat-yam'},
    {label: 'קריית מוצקין', value: 'kiryat-motzkin'},
    {label: 'עכו', value: 'acre-haifa'},
    {label: 'טירת כרמל', value: 'tirat-carmel'},
    {label: 'יקנעם עילית', value: 'yokneam-illit'},
    {label: 'זכרון יעקב', value: 'zichron-yaakov'},
    {label: 'אור עקיבא', value: 'or-akiva'},
    {label: 'פרדס חנה-כרכור', value: 'pardes-hanna-karkur'},
  ],
  center: [
    {label: 'רמת גן', value: 'ramat-gan'},
    {label: 'פתח תקווה', value: 'petah-tikva'},
    {label: 'רחובות', value: 'rehovot'},
    {label: 'מודיעין-מכבים-רעות', value: 'modiin'},
    {label: 'רעננה', value: 'raanana'},
    {label: 'הרצליה', value: 'herzliya'},
    {label: 'כפר סבא', value: 'kfar-saba'},
    {label: 'נתניה', value: 'netanya'},
    {label: 'לוד', value: 'lod'},
    {label: 'רמלה', value: 'ramla'},
    {label: 'ראשון לציון', value: 'rishon-lezion'},
    {label: 'נס ציונה', value: 'nes-ziona'},
    {label: 'יבנה', value: 'yavne'},
    {label: 'גבעת שמואל', value: 'givat-shmuel'},
    {label: 'יהוד-מונוסון', value: 'yehud-monosson'},
    {label: 'אלעד', value: 'elad'},
    {label: 'מודיעין עילית', value: 'modiin-illit'},
    {label: 'בני ברק', value: 'bnei-brak-center'},
  ],
  'tel-aviv': [
    {label: 'תל אביב-יפו', value: 'tel-aviv-yafo'},
    {label: 'בת ים', value: 'bat-yam'},
    {label: 'חולון', value: 'holon'},
    {label: 'אור יהודה', value: 'or-yehuda'},
    {label: 'גבעתיים', value: 'givatayim'},
    {label: 'בני ברק', value: 'bnei-brak'},
    {label: 'רמת השרון', value: 'ramat-hasharon'},
    {label: 'הוד השרון', value: 'hod-hasharon'},
    {label: 'אזור', value: 'azor'},
    {label: 'קריית אונו', value: 'kiryat-ono'},
  ],
  jerusalem: [
    {label: 'ירושלים', value: 'jerusalem-city'},
    {label: 'בית שמש', value: 'beit-shemesh'},
    {label: 'מעלה אדומים', value: 'maale-adumim'},
    {label: 'מבשרת ציון', value: 'mevasseret-zion'},
    {label: 'אבו גוש', value: 'abu-ghosh'},
    {label: 'ביתר עילית', value: 'beitar-illit'},
    {label: 'גבעת זאב', value: 'givat-zev'},
    {label: 'מודיעין עילית', value: 'modiin-illit-jerusalem'},
  ],
  south: [
    {label: 'באר שבע', value: 'beer-sheva'},
    {label: 'אשדוד', value: 'ashdod'},
    {label: 'אשקלון', value: 'ashkelon'},
    {label: 'דימונה', value: 'dimona'},
    {label: 'אילת', value: 'eilat'},
    {label: 'נתיבות', value: 'netivot'},
    {label: 'שדרות', value: 'sderot'},
    {label: 'אופקים', value: 'ofakim'},
    {label: 'קריית גת', value: 'kiryat-gat'},
    {label: 'קריית מלאכי', value: 'kiryat-malakhi'},
    {label: 'ערד', value: 'arad'},
    {label: 'ירוחם', value: 'yeruham'},
    {label: 'מצפה רמון', value: 'mitzpe-ramon'},
    {label: 'יבנה', value: 'yavne-south'},
  ],
};

const sortByHebrewLabel = (options: LocationOption[]): LocationOption[] =>
  [...options].sort((a, b) => a.label.localeCompare(b.label, 'he'));

export const getIsraelCitiesByState = (stateValue: string): LocationOption[] =>
  sortByHebrewLabel(ISRAEL_CITIES_BY_STATE[stateValue] ?? []);

